import { render, staticRenderFns } from "./ClickToModal.vue?vue&type=template&id=8af917e2&"
import script from "./ClickToModal.vue?vue&type=script&lang=js&"
export * from "./ClickToModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports